module.exports = __webpack_public_path__ + "images/areamap/btn_mappin_kyushu-okinawa_sp_7875cb037905b8117403ef0909146c87.png";